document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.featured-collection-carousel');
  if (!swiperEl) return; // safety check

  new Swiper('.featured-collection-carousel', {
    slidesPerView: 1.5,
    spaceBetween: 16,
    loop: true,
    grabCursor: true,
    // ✅ ADD AUTOPLAY HERE
    autoplay: {
      delay: 3000,               // time between slides (3 seconds)
      disableOnInteraction: false, // keep autoplay running after user scrolls
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: { slidesPerView: 2 },
      1024: { slidesPerView: 4 },
    },
  });
});
